import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';

export const fmt = (iso, pattern = 'dd.MM.yyyy') => {
  if (!iso) return '—';
  try { return format(typeof iso === 'string' ? parseISO(iso) : iso, pattern, { locale: ru }); }
  catch { return '—'; }
};

export const fmtDt = (iso) => fmt(iso, 'dd.MM.yyyy HH:mm');

export const ago = (iso) => {
  if (!iso) return '—';
  try { return formatDistanceToNow(parseISO(iso), { addSuffix: true, locale: ru }); }
  catch { return '—'; }
};

export const money = (v, currency = '₽') => {
  if (v === null || v === undefined) return '—';
  return new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 0 }).format(v) + ' ' + currency;
};

export const fileSize = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1048576).toFixed(1) + ' MB';
};

export const errMsg = (err) =>
  err?.response?.data?.error || err?.message || 'Неизвестная ошибка';
